import { TextField } from '@mui/material';
import { useLanguage } from '../../../../../context/LanguageContext';
import { useSyncedInputValue } from './useSyncedInputValue';

interface TextEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

function TextEditor({ value, onChange, placeholder }: TextEditorProps) {
    const { t } = useLanguage();
    const inputRef = useSyncedInputValue(value || '');

    return (
        <TextField
            inputRef={inputRef}
            type="text"
            size="small"
            fullWidth
            defaultValue={value || ''}
            onBlur={(e) => onChange(e.target.value)}
            placeholder={placeholder || t('pages.clients.queryBuilder.simple.textPlaceholder')}
        />
    );
}

export default TextEditor;
